/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Not_Found_BodyInputs */

const en_control_not_found_body = /** @type {(inputs: Control_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This route has slipped out of reach. Reconnect with a tool or guide below.`)
};

const zh_control_not_found_body = /** @type {(inputs: Control_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有找到这个页面。`)
};

/**
* | output |
* | --- |
* | "This route has slipped out of reach. Reconnect with a tool or guide below." |
*
* @param {Control_Not_Found_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_not_found_body = /** @type {((inputs?: Control_Not_Found_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Not_Found_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_not_found_body(inputs)
	return zh_control_not_found_body(inputs)
});
export { control_not_found_body as "control.not_found.body" }